import { AnimatedSprite, Container, Sprite } from 'pixi.js';

const frames = [
  'Smoke_Frame_1',
  'Smoke_Frame_2',
  'Smoke_Frame_3',
  'Smoke_Frame_4',
  'Smoke_Frame_5',
  'Smoke_Frame_6',
  'Smoke_Frame_7',
  'Smoke_Frame_8',
  'Smoke_Frame_9',
];

export function createDioramaPieceCompletedAnimation(): Container {
  const root = new Container();
  const smoke = AnimatedSprite.fromFrames(frames).props({
    anchor: 0.5,
    parent: root,
    scale: 1.3,
  });
  smoke.animationSpeed = 0.3;
  smoke.loop = false;
  smoke.play();

  const smokePromise = new Promise<void>((resolve) => {
    smoke.onComplete = (): void => {
      smoke.visible = false;
      resolve();
    };
  });

  const shineCircle = new Sprite().props({
    parent: root,
    texture: 'Shine_Circle',
    anchor: 0.5,
    scale: 0,
  });

  const shinePromise = shineCircle
    .tweenTo(
      {
        scaleX: 3,
        scaleY: 3,
        alpha: 0,
      },
      400,
      'cubicOut',
      true,
    )
    .asyncOnComplete();

  Promise.all([smokePromise, shinePromise]).then(
    () => {
      root.destroy({ children: true });
    },
    () => {},
  );

  return root;
}
